module.exports = __webpack_public_path__ + "static/media/pefin-assistant-03.e27dee2f.png";